import React from 'react';
import Button from '@/components/ui/Button';
import { COMPANY_INFO } from '@/lib/constants';
import { Phone, Calendar, Sparkles } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="bg-gradient-to-br from-orcsys-500 to-orcsys-600 py-16 lg:py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMS41IiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1vcGFjaXR5PSIwLjEiPjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjE1Ii8+PHBhdGggZD0iTTMwIDE1TDQ1IDMwIDMwIDQ1IDE1IDMweiIvPjwvZz48L3N2Zz4=')] opacity-30" />
      
      <div className="container px-4 mx-auto relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm mb-6">
            <Sparkles className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Votre idée mérite mieux qu'un PowerPoint.
          </h2>
          <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto">
            En moins d'un mois, obtenez un prototype convaincant, mesurable et prêt à présenter.
            Testez, ajustez, et passez à la suite avec des preuves — pas des suppositions.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button.Link 
              href={`tel:${COMPANY_INFO.phone}`}
              className="bg-white text-orcsys-600 hover:bg-white/90 group"
              size="lg"
            >
              <Phone className="w-5 h-5 mr-2 group-hover:animate-pulse" />
              Réservez votre appel découverte (15 min)
            </Button.Link>
            <Button.Link 
              href="#book"
              variant="outline"
              className="border-white text-white hover:bg-white/10 group"
              size="lg"
            >
              <Calendar className="w-5 h-5 mr-2 group-hover:rotate-12 transition-transform" />
              Planifier un rendez-vous
            </Button.Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;

